import {
  Gauge, Trophy, Users, Layers, BarChart3, Smartphone, Calendar, Gamepad2, QrCode,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  to: string;
  labelKey: string;
  fallback: string;
  icon: LucideIcon;
  /** Přesná shoda cesty — jinak by „Přehled“ na / svítilo pořád. */
  end?: boolean;
}

export interface NavSection {
  titleKey: string;
  fallback: string;
  items: NavItem[];
}

export const NAV: NavSection[] = [
  {
    titleKey: 'nav.section.ops',
    fallback: 'Provoz',
    items: [
      { to: '/', labelKey: 'nav.dashboard', fallback: 'Přehled', icon: Gauge, end: true },
      { to: '/hry', labelKey: 'nav.games', fallback: 'Hry', icon: Trophy },
      { to: '/clenove', labelKey: 'nav.members', fallback: 'Členové', icon: Users },
      { to: '/skupiny', labelKey: 'nav.groups', fallback: 'Skupiny', icon: Layers },
      { to: '/statistiky', labelKey: 'nav.stats', fallback: 'Statistiky', icon: BarChart3 },
      { to: '/qr-kody', labelKey: 'nav.qrCodes', fallback: 'QR kódy', icon: QrCode },
    ],
  },
  {
    titleKey: 'nav.section.settings',
    fallback: 'Nastavení',
    items: [
      { to: '/zarizeni', labelKey: 'nav.devices', fallback: 'Zařízení', icon: Smartphone },
      { to: '/epochy', labelKey: 'nav.epochs', fallback: 'Epochy', icon: Calendar },
      { to: '/herni-mody', labelKey: 'nav.gameTypes', fallback: 'Herní módy', icon: Gamepad2 },
    ],
  },
];
